var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMdmBgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.54 144.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#Degradado_sin_nombre_156);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_156",
    x1: 99.22,
    y1: 25.19,
    x2: 45.09,
    y2: 118.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0378fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#027bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0286f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0199e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#01b3d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00d4b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dab6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 144.54,
    height: 144.54,
    rx: 42.67,
    ry: 42.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.96,32.44l-33.08,34.08L33.56,31.22v18.82l26.19,26.63-6.12,6.12-7.61,7.7-.21-6.48-13.04-.42,.93,28.8,28.73,.93-.42-13.04-6.57-.21,7.65-7.68,6.11-6.11,24.47,24.88h18.11V32.44h-8.81Zm-19.65,39.6l15.62-15.27v39.05l-20.09-19.19,4.55-4.55-.09-.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdmBgWhite);
export default __webpack_public_path__ + "static/media/icon-mdm-bg-white.f439bae06d43d44c512b8986916a9450.svg";
export { ForwardRef as ReactComponent };